import { relations } from 'drizzle-orm'
import { index, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core'
import { users } from '../schema'
import { tenants } from './tenants'
import { trainingEnrollments } from './training-enrollment'

// Training Approvals
export const trainingApprovals = pgTable(
  'training_approvals',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    enrollmentId: uuid('enrollment_id')
      .notNull()
      .references(() => trainingEnrollments.id, { onDelete: 'cascade' }),
    approverId: uuid('approver_id')
      .notNull()
      .references(() => users.id),
    status: text('status').notNull().default('pending'),
    comment: text('comment'),
    proxyApproverId: uuid('proxy_approver_id').references(() => users.id),
    decidedAt: timestamp('decided_at'),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id, { onDelete: 'cascade' }),
    createdAt: timestamp('created_at').defaultNow().notNull(),
  },
  (table) => ({
    enrollmentIdIdx: index('training_approvals_enrollment_id_idx').on(table.enrollmentId),
    approverIdIdx: index('training_approvals_approver_id_idx').on(table.approverId),
    tenantIdIdx: index('training_approvals_tenant_id_idx').on(table.tenantId),
    tenantStatusIdx: index('training_approvals_tenant_status_idx').on(table.tenantId, table.status),
  }),
)

// Relations
export const trainingApprovalsRelations = relations(trainingApprovals, ({ one }) => ({
  enrollment: one(trainingEnrollments, {
    fields: [trainingApprovals.enrollmentId],
    references: [trainingEnrollments.id],
  }),
  approver: one(users, {
    fields: [trainingApprovals.approverId],
    references: [users.id],
  }),
}))

// Type exports
export type TrainingApproval = typeof trainingApprovals.$inferSelect
export type NewTrainingApproval = typeof trainingApprovals.$inferInsert
